export const environment = {
  // apiBaseUrl: "http://localhost:7000",

// apiBaseUrl: "http://localhost:5005",
apiBaseUrl:"https://lmsapi.xenovex.com",
// apiBaseUrl:"https://lmsapi.tnega.org",
// imageBaseUrl: "https://lmsimages.tnega.org/",


  imageBaseUrl: "https://lmsimages.xenovex.com/",
  
  
  tokenEndPoint: "/api/token",
  production: false,
  environment: "Local",
  showEnvironment: true,
  chennaiId: 2
};
